/**
 * Author: zoesvision.com
 * Purpose: Shared thumbnail and color-swatch preview behavior for Z product grid cards.
 */

(() => {
  class ZProductGridCard extends HTMLElement {
    connectedCallback() {
      if (this.zConnected) return;
      this.zConnected = true;
      this.addEventListener('mouseover', this.zHandlePreviewStart);
      this.addEventListener('mouseout', this.zHandlePreviewEnd);
      this.addEventListener('focusin', this.zHandlePreviewStart);
      this.addEventListener('focusout', this.zHandlePreviewEnd);
    }

    disconnectedCallback() {
      this.zConnected = false;
      this.removeEventListener('mouseover', this.zHandlePreviewStart);
      this.removeEventListener('mouseout', this.zHandlePreviewEnd);
      this.removeEventListener('focusin', this.zHandlePreviewStart);
      this.removeEventListener('focusout', this.zHandlePreviewEnd);
    }

    zHandlePreviewStart = (event) => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('[data-z-card-preview-src]');
      if (!trigger || !this.contains(trigger) || trigger.contains(event.relatedTarget)) return;

      const image = this.querySelector('.z-product-grid-card__image');
      if (!image) return;
      image.dataset.zDefaultSrc ||= image.getAttribute('src') || '';
      image.dataset.zDefaultSrcset ||= image.getAttribute('srcset') || '';
      image.dataset.zDefaultAlt ||= image.getAttribute('alt') || '';
      image.removeAttribute('srcset');
      image.src = trigger.dataset.zCardPreviewSrc;
      image.alt = trigger.dataset.zCardPreviewAlt || image.dataset.zDefaultAlt;
    };

    zHandlePreviewEnd = (event) => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('[data-z-card-preview-src]');
      if (!trigger || !this.contains(trigger) || trigger.contains(event.relatedTarget)) return;

      const image = this.querySelector('.z-product-grid-card__image');
      if (!image?.dataset.zDefaultSrc) return;
      image.src = image.dataset.zDefaultSrc;
      if (image.dataset.zDefaultSrcset) image.srcset = image.dataset.zDefaultSrcset;
      image.alt = image.dataset.zDefaultAlt;
    };
  }

  if (!customElements.get('z-product-grid-card')) {
    customElements.define('z-product-grid-card', ZProductGridCard);
  }
})();
